import { render, staticRenderFns } from "./cDocumentAdd.vue?vue&type=template&id=6df8dfbf&scoped=true"
import script from "./cDocumentAdd.vue?vue&type=script&lang=js"
export * from "./cDocumentAdd.vue?vue&type=script&lang=js"
import style0 from "./cDocumentAdd.vue?vue&type=style&index=0&id=6df8dfbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df8dfbf",
  null
  
)

export default component.exports